import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../..";
import FacilityTypeStep from "../../../../../../shared/wizard/steps/facilityTypeStep";

interface IWishStep_2 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStep_2 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: IWishStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_1);
    onReset(["selectedFacilityTypeIds"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_3);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      onChange(
        data.filter((id) => id !== selectedId),
        "selectedFacilityTypeIds"
      );
      return;
    }

    onChange([selectedId], "selectedFacilityTypeIds");
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="default"
      />
    </div>
  );
};

export default WishStep_2;
